import useAuth from "../../hooks/authenticate/useAuth";
import useConfig from "../../hooks/useConfig";
import AtidimChartsWeekly from "./AtidimContainer/AtidimChartsWeekly";
import AtidimCombinedComponents from "./AtidimContainer/AtidimCombinedComponents";
// import AtidimReports from "./AtidimContainer/AtidimReports";
// import ChartsToday from "./AtidimContainer/ChartsToday";

const AtidimContainer = () => {
  const { auth } = useAuth();
  const { config } = useConfig();
  return (
    <div className="w-full h-full flex flex-col items-center justify-center p-4 shadow-xl  backdrop-blur-xl  bg-blue-900 bg-opacity-30  rounded-xl ">
      <div className="w-full">
        {/* <ChartsToday token={auth.token} /> */}
        <AtidimCombinedComponents
          token={auth.token}
          areas={config.areas}
          map={config.map}
        />
      </div>
      <div className=" w-full h-1/2 flex justify-center  rounded-xl    ">
        <div className="w-full h-full ">
          <AtidimChartsWeekly token={auth.token} />
        </div>
        {/* <div className="w-1/2">
          <AtidimReports />
        </div> */}
      </div>
    </div>
  );
};
export default AtidimContainer;
